module.exports = __webpack_public_path__ + "img/companyIntro10.c3ed37e0.png";